import React, { useId, useRef, useEffect } from 'react';

function InputBox({ 
  label, 
  reference,
  type = "text", 
  name, 
  value, 
  onValueChange, 
  placeholder, 
  required = false, 
  style = {}, 
  className = "", 
  pattern = "",
  onNext,
  icon,
  errorMessage = "",
  onClick,
  disabled = false
}) {
  const inputRef = useRef();
  const generatedId = useId();
  const inputId = name || generatedId;
  const errorId = `${inputId}-error`;
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onNext) {
      e.preventDefault();
      onNext();
    }
  };

  // Combined ref for external and internal usage
  useEffect(() => {
    if (reference) {
      reference.current = inputRef.current;
    }
  }, [reference]);

  return (
    <div className={`relative ${className}`} style={style}>
      {label && (
        <label
          htmlFor={inputId}
          className="mb-2 ml-0.5 block text-[12px] font-bold text-ink"
        >
          {label} {required && <span className="text-debit">*</span>}
        </label>
      )}
      <div 
        className={`
          relative flex min-h-[52px] items-center rounded-2xl border transition duration-200
          ${disabled ? 'bg-paper opacity-70 cursor-not-allowed' : 'bg-white'}
          ${errorMessage 
            ? 'border-debit/70 ring-4 ring-debit/10'
            : 'border-line shadow-[0_2px_8px_rgba(20,35,58,0.04)] focus-within:border-primary focus-within:ring-4 focus-within:ring-primary/10'
          }
        `}
      >
        {icon && (
          <div className="pl-3.5 text-[#6B7280]">
            {icon}
          </div>
        )}
        
        <input
          ref={inputRef}
          type={type}
          name={name}
          id={inputId}
          value={value}
          onChange={onValueChange}
          onKeyDown={handleKeyDown}
          onClick={onClick}
          placeholder={placeholder}
          required={required}
          pattern={pattern}
          disabled={disabled}
          aria-invalid={Boolean(errorMessage)}
          aria-describedby={errorMessage ? errorId : undefined}
          className={`
            w-full bg-transparent py-3.5 text-[15px] font-semibold text-ink outline-none
            ${icon ? 'pl-2.5 pr-4' : 'px-4'}
            ${disabled ? 'text-muted' : 'text-ink'}
            placeholder:text-[#98A2B3]
          `}
        />
      </div>
      
      {errorMessage && (
        <p id={errorId} className="ml-1 mt-1.5 text-[11.5px] font-semibold text-debit">
          {errorMessage}
        </p>
      )}
    </div>
  );
}

export default InputBox;
